import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider, useSettings } from './context/SettingsContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Hotels from './pages/Hotels';
import HotelForm from './pages/HotelForm';
import Spas from './pages/Spas';
import SpaForm from './pages/SpaForm';
import Tours from './pages/Tours';
import TourForm from './pages/TourForm';
import TravelPackages from './pages/TravelPackages';
import TravelPackageForm from './pages/TravelPackageForm';
import OwnerRegistration from './pages/OwnerRegistration';
import Settings from './pages/Settings';
import Facilities from './pages/Facilities';
import FacilityForm from './pages/FacilityForm';
import Amenities from './pages/Amenities';
import AmenityForm from './pages/AmenityForm';
import HotelCategories from './pages/HotelCategories';
import HotelCategoryForm from './pages/HotelCategoryForm';
import Customers from './pages/Customers';
import CustomerForm from './pages/CustomerForm';
import Wishlists from './pages/Wishlists';
import PushNotifications from './pages/PushNotifications';
import PushNotificationForm from './pages/PushNotificationForm';
import SuggestedDestinations from './pages/SuggestedDestinations';
import SuggestedDestinationForm from './pages/SuggestedDestinationForm';
import VerificationSubscriptions from './pages/VerificationSubscriptions';
import VerificationSubscriptionForm from './pages/VerificationSubscriptionForm';
import FeaturedSubscriptions from './pages/FeaturedSubscriptions';
import FeaturedSubscriptionForm from './pages/FeaturedSubscriptionForm';
import SubscriptionHistory from './pages/SubscriptionHistory';
import LegalPages from './pages/LegalPages';
import LegalPageForm from './pages/LegalPageForm';
import LegalPageView from './pages/LegalPageView';
import LandingPage from './pages/LandingPage';
import './App.css';

// Component to update document title
const TitleUpdater = () => {
  const { companyName } = useSettings();
  
  useEffect(() => {
    if (companyName) {
      document.title = `${companyName} - Admin Panel`;
    }
  }, [companyName]);
  
  return null;
};

function App() {
  return (
    <SettingsProvider>
      <TitleUpdater />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/sy-admin/login" element={<Login />} />
            <Route
              path="/sy-admin"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/hotels"
              element={
                <PrivateRoute>
                  <Hotels />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/hotels/new"
              element={
                <PrivateRoute>
                  <HotelForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/hotels/edit/:id"
              element={
                <PrivateRoute>
                  <HotelForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/spas"
              element={
                <PrivateRoute>
                  <Spas />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/spas/new"
              element={
                <PrivateRoute>
                  <SpaForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/spas/edit/:id"
              element={
                <PrivateRoute>
                  <SpaForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/tours"
              element={
                <PrivateRoute>
                  <Tours />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/tours/new"
              element={
                <PrivateRoute>
                  <TourForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/tours/edit/:id"
              element={
                <PrivateRoute>
                  <TourForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/travel-packages"
              element={
                <PrivateRoute>
                  <TravelPackages />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/travel-packages/new"
              element={
                <PrivateRoute>
                  <TravelPackageForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/travel-packages/edit/:id"
              element={
                <PrivateRoute>
                  <TravelPackageForm />
                </PrivateRoute>
              }
            />
          <Route path="/list-your-property" element={<OwnerRegistration />} />
          <Route path="/owner-registration" element={<OwnerRegistration />} />
          <Route
            path="/sy-admin/settings"
            element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/facilities"
            element={
              <PrivateRoute>
                <Facilities />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/facilities/new"
            element={
              <PrivateRoute>
                <FacilityForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/facilities/edit/:id"
            element={
              <PrivateRoute>
                <FacilityForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/amenities"
            element={
              <PrivateRoute>
                <Amenities />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/amenities/new"
            element={
              <PrivateRoute>
                <AmenityForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/amenities/edit/:id"
            element={
              <PrivateRoute>
                <AmenityForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/hotel-categories"
            element={
              <PrivateRoute>
                <HotelCategories />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/hotel-categories/new"
            element={
              <PrivateRoute>
                <HotelCategoryForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/hotel-categories/edit/:id"
            element={
              <PrivateRoute>
                <HotelCategoryForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/customers"
            element={
              <PrivateRoute>
                <Customers />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/customers/edit/:id"
            element={
              <PrivateRoute>
                <CustomerForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/wishlists"
            element={
              <PrivateRoute>
                <Wishlists />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/push-notifications"
            element={
              <PrivateRoute>
                <PushNotifications />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/push-notifications/new"
            element={
              <PrivateRoute>
                <PushNotificationForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/push-notifications/edit/:id"
            element={
              <PrivateRoute>
                <PushNotificationForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/suggested-destinations"
            element={
              <PrivateRoute>
                <SuggestedDestinations />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/suggested-destinations/new"
            element={
              <PrivateRoute>
                <SuggestedDestinationForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/suggested-destinations/edit/:id"
            element={
              <PrivateRoute>
                <SuggestedDestinationForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/verification-subscriptions"
            element={
              <PrivateRoute>
                <VerificationSubscriptions />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/verification-subscriptions/new"
            element={
              <PrivateRoute>
                <VerificationSubscriptionForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/verification-subscriptions/edit/:id"
            element={
              <PrivateRoute>
                <VerificationSubscriptionForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/featured-subscriptions"
            element={
              <PrivateRoute>
                <FeaturedSubscriptions />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/featured-subscriptions/new"
            element={
              <PrivateRoute>
                <FeaturedSubscriptionForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/featured-subscriptions/edit/:id"
            element={
              <PrivateRoute>
                <FeaturedSubscriptionForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/subscription-history"
            element={
              <PrivateRoute>
                <SubscriptionHistory />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/legal-pages"
            element={
              <PrivateRoute>
                <LegalPages />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/legal-pages/new"
            element={
              <PrivateRoute>
                <LegalPageForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/legal-pages/edit/:id"
            element={
              <PrivateRoute>
                <LegalPageForm />
              </PrivateRoute>
            }
          />
          {/* Public legal page view */}
          <Route path="/page/:slug" element={<LegalPageView />} />
          {/* Landing page */}
          <Route path="/" element={<LandingPage />} />
          {/* Redirect unknown admin routes to admin dashboard */}
          <Route path="/sy-admin/*" element={<Navigate to="/sy-admin" replace />} />
          {/* Redirect old routes to new admin routes */}
          <Route path="/login" element={<Navigate to="/sy-admin/login" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </SettingsProvider>
  );
}

export default App;

